<template>
  <div class="empty-wrapper">
    <img :src="icon || emptyImg" />
    <p>{{ message }}</p>
  </div>
</template>

<script>
import emptyImg from '@/assets/image/empty.png'
export default {
  props: {
    message: {
      type: String,
      default: '暂无相关信息'
    },
    icon: String
  },
  data() {
    return {
      emptyImg
    }
  }
}
</script>

<style lang="less" scoped>
.empty-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 192px;
  width: 100%;
  background: #ffffff;
  margin-bottom: 24px;
  img {
    width: 124px;
  }
  p {
    margin-top: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #cccccc;
    text-align: center;
    line-height: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Empty.vue